import { useState, useRef } from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  useIsMobile,
} from '@wellesley/ui'
import { CurrentUserCard } from '../CurrentUserCard'
import { UserMenu } from './UserMenu'
import { useResize } from 'hooks/useResize'
import MobileBottomModal from 'components/mobile/MobileBottomModal'

export const UserMenuDropdown = ({ tooltipText }: { tooltipText?: string }) => {
  const [open, setOpen] = useState(false)
  const [positionKey, setPositionKey] = useState(0)
  const triggerRef = useRef<HTMLDivElement>(null)
  const isMobile = useIsMobile()

  const handleClose = () => {
    setOpen(false)
  }

  useResize(() => {
    if (open) {
      setPositionKey((prev) => prev + 1)
    }
  })

  const triggerNode = (
    <div
      ref={triggerRef}
      data-testid="user-menu-trigger"
      className="gap-xxs flex max-w-full items-center justify-between truncate"
    >
      <CurrentUserCard onlyAvatar avatarClassName="2xl:h-10 2xl:w-10" />
    </div>
  )

  if (isMobile) {
    return (
      <MobileBottomModal
        testId="user-menu-bottom-modal"
        childrenClassName="!p-0"
        renderToggler={(toggle) => <div onClick={toggle}>{triggerNode}</div>}
        renderContent={({ setOpen: setModalOpen }) => (
          <UserMenu onClose={() => setModalOpen(false)} />
        )}
      />
    )
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      {tooltipText ? (
        <Tooltip open={open ? false : undefined}>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>{triggerNode}</DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent
            side="right"
            sideOffset={15}
            size="default"
            theme="dark"
          >
            {tooltipText}
          </TooltipContent>
        </Tooltip>
      ) : (
        <DropdownMenuTrigger asChild>{triggerNode}</DropdownMenuTrigger>
      )}
      <DropdownMenuContent
        key={positionKey}
        sideOffset={20}
        alignOffset={-14}
        side="right"
        align="end"
        isPortal={true}
        avoidCollisions={true}
        collisionPadding={8}
        sticky="always"
        className="!p-none flex min-w-[300px] flex-col rounded-lg"
      >
        <UserMenu onClose={handleClose} />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
